import { memo } from 'react';
import { SearchState } from '../../types/index';

type Props = {
  suggestionResults: SearchState['suggestionResults'] | null;
  submitSearch: (term: string, type: string, url?: string) => string;
  setSearchTerm: (term: string) => void;
  searchFromSuggestion: (term: string, type: string) => void;
  clickSuggestedTerm: (type: string) => void;
};

const SuggestionBrandsResults = ({
  suggestionResults,
  submitSearch,
  setSearchTerm,
  searchFromSuggestion,
  clickSuggestedTerm,
}: Props) => {
  return (
    <>
      {suggestionResults?.brands
        ? suggestionResults.brands.map((brand: string) => {
            return (
              <div
                key={`brand-results-${brand}`}
                data-testid="sayt-suggested-brands"
                className="dsg-search-suggestion-result-container">
                <button
                  type="button"
                  className="dsg-search-suggestion-result hmf-text-align-left hmf-body-l hmf-body-m-m"
                  onMouseEnter={() => searchFromSuggestion(brand, 'brand')}
                  onFocus={() => searchFromSuggestion(brand, 'brand')}
                  onClick={(e) => {
                    e.preventDefault();
                    setSearchTerm(brand);
                    clickSuggestedTerm('brand');
                    window.location.href = submitSearch(brand, 'brand', brand);
                  }}>
                  <span>{brand}</span>
                </button>
              </div>
            );
          })
        : ''}
    </>
  );
};

export default memo(
  SuggestionBrandsResults,
  (prev, next) => prev.suggestionResults === next.suggestionResults,
);
